import { useLiveQuery } from 'dexie-react-hooks';
import db from '../db/localDB';

export function usePendingCount(userId) {
  const count = useLiveQuery(
    () => userId
      ? db.pending_sales.where({ user_id: userId, sync_status: 'pending' }).count()
      : Promise.resolve(0),
    [userId],
    0
  );
  return count ?? 0;
}
export default usePendingCount;
